/* eslint-disable react-hooks/exhaustive-deps */
import React, {Fragment, useEffect, useState} from 'react';
import {useRouteMatch} from 'react-router-dom';
import Container from '@material-ui/core/Container';
import makeStyles from '@material-ui/core/styles/makeStyles';
import service from '../services/api';

const useStyles = makeStyles({
  root: {
    '& p': {
      fontWeight: '400',
      color: '#666',
    },
    '& .ubtn-fade-bg': {
      borderRadius: "5px",
      padding: "6px",
      width: "100px",
    },
     '& .ubtn-ctn-center': {
     display:"flex",
     justifyContent: "center"    
    },
     '& .vc_row-has-fill': {
      backgroundColor: "transparent !important" 
    },
     '& .wpb_text_column .wpb_wrapper h1 ': {
    textAlign: "center !important",
    marginBottom: "30px !important"
    },
  }

});

// Cms.propTypes = {};

function Cms(props) {
  const classes = useStyles();

  const [body, setBody] = useState('');
  const [layout, setLayout] = useState('');
  const match = useRouteMatch('/info/:title');

  useEffect(() => {
    if (match.params.title) {
      service.cms.find({query: {title: match.params.title}}).then(({data}) => {
        if (data.length) {
          setLayout(data[0].layout);
          setBody(data[0].body);
        } else {
          setLayout('');
          setBody('');
        }
      });
    }
  }, [match.params.title]);

  const Content = layout === 'fullwidth' ? Fragment : Container;

  return (
    <Content>
      <div className={classes.root} dangerouslySetInnerHTML={{__html: body}} />
    </Content>
  );
}

export default Cms;
